import { render } from "./App.vue?vue&type=template&id=f7c2bdb6"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/htdocs/studio100-cmp/resources/vue-apps/njam-2-search/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__